import { render, staticRenderFns } from "./TableProducts.vue?vue&type=template&id=2db5f099&scoped=true&"
import script from "./TableProducts.vue?vue&type=script&lang=js&"
export * from "./TableProducts.vue?vue&type=script&lang=js&"
import style0 from "./TableProducts.vue?vue&type=style&index=0&id=2db5f099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.12_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5f099",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/.pnpm/vuetify-loader@1.7.2_vue-template-compiler@2.6.12_vuetify@2.5.0_webpack@4.46.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTooltip})
